import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { CardHeader, CardTitle } from "../../ui/card";

interface OverviewCardHeaderProps {
  title: string;
  description: string;
  icon: LucideIcon;
  fromdetails: boolean;
  detail?: string;
  actions?: ReactNode;
  className?: string;
  titleClassName?: string;
}

export default function OverviewCardHeader({
  title,
  description,
  icon: Icon,
  fromdetails,
  detail,
  actions,
  className,
  titleClassName,
}: OverviewCardHeaderProps) {
  if (!fromdetails) {
    return (
      <CardHeader className={className}>
        <CardTitle className={titleClassName}>{title}</CardTitle>
      </CardHeader>
    );
  }

  return (
    <CardHeader className="overview-card-header">
      <div className="overview-card-heading">
        <span className="overview-heading-icon" aria-hidden="true">
          <Icon />
        </span>
        <div className="overview-heading-copy">
          <h2 className="overview-card-title">{title}</h2>
          <p className="overview-card-description">{description}</p>
        </div>
      </div>
      {actions ? (
        <div className="overview-card-header-actions">
          {detail && <span className="overview-card-detail">{detail}</span>}
          {actions}
        </div>
      ) : (
        detail && <span className="overview-card-detail">{detail}</span>
      )}
    </CardHeader>
  );
}
